import DOMPurify from "dompurify";

const allowedParagraphClasses = new Set(["fancy", "simple"]);

const sanitizeParagraphClasses = (html: string): string => {
  if (typeof window === "undefined" || typeof window.DOMParser !== "function") {
    return html;
  }

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("p").forEach((element) => {
    const paragraph = element as HTMLElement;
    const filteredClasses = Array.from(paragraph.classList).filter((name) =>
      allowedParagraphClasses.has(name),
    );

    if (filteredClasses.length === 0) {
      paragraph.removeAttribute("class");
      return;
    }

    paragraph.className = filteredClasses.join(" ");
  });

  return doc.body.innerHTML;
};

export const sanitizeAllowed = (htmlString: string): string => {
  const sanitized = DOMPurify.sanitize(htmlString, {
    ALLOWED_TAGS: ["p", "em", "strong"],
    ALLOWED_ATTR: ["class"],
  });

  if (!sanitized) {
    return "";
  }

  return sanitizeParagraphClasses(sanitized);
};
